import { useState } from 'react';
import {
  FaBars,
  FaCar,
  FaCheckCircle,
  FaDollarSign,
  FaLifeRing,
  FaSignOutAlt,
  FaSpinner,
  FaTachometerAlt,
  FaTimesCircle,
  FaUserCircle,
  FaUsers,
  FaCreditCard,
  FaUserShield
} from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import '../../../assets/css/Admin/general/AdminSidebar.css';

const AdminSidebar = ({ screenName }) => {
  const [activeMenu, setActiveMenu] = useState(screenName || 'dashboard');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  const menuItems = [
    { id: 'dashboard', label: 'Dashboard', icon: <FaTachometerAlt />, path: '/admin-dashboard' },
    { id: 'sub-admin', label: 'Sub-Admin', icon: <FaUserShield />, path: '/admin/sub-admin' },
    { id: 'customers', label: 'All Customers', icon: <FaUsers />, path: '/admin/all-customers' },
    { id: 'drivers', label: 'All Drivers', icon: <FaCar />, path: '/admin/all-drivers' },
    { id: 'installments', label: 'Installments', icon: <FaCreditCard />, path: '/admin/installment' },
    { id: 'ongoing', label: 'Ongoing Orders', icon: <FaSpinner />, path: '/admin/ongoing-orders' },
    { id: 'completed', label: 'Completed Orders', icon: <FaCheckCircle />, path: '/admin/completed-orders' },
    { id: 'cancelled', label: 'Cancelled Orders', icon: <FaTimesCircle />, path: '/admin/cancelled-orders' },
    { id: 'help', label: 'Help and Support', icon: <FaLifeRing />, path: '/admin/help-support' },
    { id: 'earnings', label: 'Earnings', icon: <FaDollarSign />, path: '/admin/earnings' },
    { id: 'profile-setting', label: 'Profile Settting', icon: <FaUserCircle />, path: '/admin/profile' },

  ];


  const handleMenuClick = (itemId) => {
    setActiveMenu(itemId);
    setMobileMenuOpen(false);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };
  const handleLogout = () => {
    // Clear any authentication tokens/data
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminData');

    // Close mobile menu if open
    setMobileMenuOpen(false);

    // Redirect to login page
    navigate('/admin-login');
  };

  return (
    <>
      {/* Mobile Menu Toggle Button */}
      <button
        className="admin-sidebar-toggle-btn"
        onClick={toggleMobileMenu}
        aria-label="Toggle Menu"
      >
        <FaBars />
      </button>

      {/* Mobile Overlay */}
      <div
        className={`admin-sidebar-overlay ${mobileMenuOpen ? 'active' : ''}`}
        onClick={() => setMobileMenuOpen(false)}
      ></div>

      {/* Sidebar */}
      <aside className={`admin-sidebar ${mobileMenuOpen ? 'mobile-open' : ''}`}>
        <nav className="admin-sidebar-nav">
          <ul className="admin-sidebar-menu-list">
            {menuItems.map((item) => (
              <li
                key={item.id}
                className={`admin-sidebar-menu-item ${activeMenu === item.id ? 'active' : ''}`}
              >
                <Link
                  to={item.path}
                  className="admin-sidebar-menu-link"
                  onClick={() => handleMenuClick(item.id)}
                >
                  <span className="admin-sidebar-menu-icon">{item.icon}</span>
                  <span className="admin-sidebar-menu-label">{item.label}</span>
                </Link>
              </li>
            ))}
            {/* Logout Button */}
            <li className="admin-sidebar-menu-item admin-sidebar-logout-item">
              <div
                className="admin-sidebar-menu-link admin-sidebar-logout-link"
                onClick={handleLogout}
              >
                <span className="admin-sidebar-menu-icon"><FaSignOutAlt /></span>
                <span className="admin-sidebar-menu-label">Logout</span>
              </div>
            </li>

          </ul>
        </nav>
      </aside>
    </>
  );
};

export default AdminSidebar;